export default "__VITE_ASSET__L_Jz7CwV__"